import { gql } from '@apollo/client'

const userProfileSection = `{
    empId
    userId
    familyName
    firstName
    primaryRole
    profileCd
    authProfileCd
    enabled
    lastLogin
    accessDartCost
    restrictBDM
    asmProfile
    accessCost
    editSRWinLoss
    primaryRegion
    srOpenAllDeals
    srEditAllDeals
    asapRole
    tenantId
    tenantIdDealOverrideFlag
    federalAccessFlag
    accountHistoryFlag
    countryCd
    dealTemplateAccess
    templateManagementFlag
    adminModuleFlag
    catalogAdminFlag
    catalogReadonlyFlag
  }`

const securityProfileResult = `{
    profileCode
    dealStatusActions {
      dealStatus
      actions {
        actionDescription
        actionId
        actionValue
      }
    }
  }`

const authProfileMatrixSection = `{
    authProfileCd
    regionCd
    subRegion
    countryCd
    busModelCd
    mcChargeCd
    busGroupCd
    busUnitcd
    prodLineCd
    prodFamCode
    dealTypeCd
    maxApprovalPct
    minMarginApprovalPct
    authMarginFL
    plSummaryAuth
    maxLineUsdAmt
    creationDts
    updateDts
    lastChangeEmpNR
  }`

const guidanceRoleSection = `{
    guidanceRoleId
    guidanceRoleDesc
    activeFL
    defaultBenchMarkFL
    allowGBAPNBD
    authBenchmarkFL
    authAdjustmentPCT
    showExpertFL
    showTypicalFL
    showFloorFL
    creationDTS
    updateDTS
    lastChangeEmpNR
    primaryRole
    showMaxApprovalFL
    showPartialColorFL
    showGuidanceDetailsFL
    negativeMarginAprvlFL
    showPricingBandFL
    guidanceAuthProfileCD
    showExcludeInheritPQBFL
    approveExcludePQBFL
    approveInheritPQBFL
    allowGBAPLPFFL
    showGuidancePLPFFL
  }`

export const GET_USER_PROFILE_QUERY = gql`
query GetUserProfile($email: String!, $client_id: String!) {
  userSecurityProfile(email: $email, client_id: $client_id) {
    didError
    errorCode
    errorMessage
    infoMessage
    securityProfile {
      userEmail
      isEnabled
      isDealManagerAccess
      isPriceHubAccess
      isActionClientAccess
      isAdminUserAccess
      isPowerUserAccess
      message
      userProfile ${userProfileSection}
      securityProfile ${securityProfileResult}
      readOnlyProfile ${securityProfileResult}
      authProfileMatrix ${authProfileMatrixSection}
      guidanceRole ${guidanceRoleSection}
    }
  }
}
`
